export const processNestedGroups = (data, level = 0, result = [], parentGroup = null) => {
  if (!Array.isArray(data)) return result;
  
  data.forEach(item => {
    if (item.title && Array.isArray(item.items)) {
      const groupId = item.data?.id || null;
      const groupItem = {
        isGroupHeader: true,
        title: item.title,
        style: item.style || {
          color: '#000000',
          fontSize: 12,
          bold: true,
          background: '#ffffff'
        },
        level: level,
        items: item.items,
        data: item.data || {},
        groupId: groupId,
        isParent: false
      };
      result.push(groupItem);
      processNestedGroups(item.items, level + 1, result, groupItem);
    } else if (Array.isArray(item)) {
      processNestedGroups(item, level, result, parentGroup);
    } else if (item.type === 'row' && item.data) {
      result.push({
        isGroupHeader: false,
        data: item.data,
        level: level,
        groupId: parentGroup ? parentGroup.groupId : null
      });
    } else {
      result.push({
        isGroupHeader: false,
        data: item,
        level: level,
        groupId: parentGroup ? parentGroup.groupId : null
      });
    }
  });
  
  return result;
};

export const processWBSGroups = (data, level = 0, result = [], parentId = null) => {
  if (!Array.isArray(data)) return result;
  
  data.forEach(item => {
    const currentItem = {
      type: item.type || 'row',
      level: item.level || level,
      data: item.data || {},
      isParent: item.type === 'parent',
      items: item.items || [],
      parentId: parentId,
      groupId: parentId
    };
    result.push(currentItem);
    
    if (item.items && Array.isArray(item.items)) {
      processWBSGroups(item.items, level + 1, result, item.data?.id || item.data?.ID || null);
    }
  });
  
  return result;
};

export const processFlatTasks = (data) => {
  if (!Array.isArray(data)) return [];
  return data.map(item => ({
    type: item.type || 'row',
    level: 0,
    data: item.data || {},
    isParent: false,
    items: [],
    groupId: null
  }));
};